(ns common.specs.universal
  (:require [clojure.spec.alpha :as s]
            [clojure.spec.gen.alpha :as gen]
            [clojure.test.check.generators]))

(def non-empty-string-alphanumeric
  (gen/such-that #(not= "" %) (gen/string-alphanumeric)))

(def uuid-pattern
  "[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}")

(def uuid-v4-or-v7?
  (let [pattern (re-pattern (str "^" uuid-pattern "$"))]
    #(boolean (re-seq pattern %))))

(s/def :common/uuid
  (s/with-gen (s/and string? uuid-v4-or-v7?)
    #(gen/fmap str (gen/uuid))))

(s/def :common/http-verb
  #{"CONNECT"
    "DELETE"
    "GET"
    "HEAD"
    "OPTIONS"
    "PATCH"
    "POST"
    "PUT"})

(s/def :common/date
  (s/with-gen (s/and string? #(re-matches #"^\d{4}-\d{2}-\d{2}$" %))
    (fn [] (gen/fmap #(subs (.toISOString %) 0 10) (s/gen inst?)))))

(s/def :common/date-time
  (s/with-gen (s/and string? #(false? (js/isNaN (js/Date. %))))
    (fn [] (gen/fmap #(.toISOString %) (s/gen inst?)))))

(def email-generator
  (gen/fmap (fn [[name host tld]] (str name "@" host "." tld))
            (gen/tuple non-empty-string-alphanumeric
                       non-empty-string-alphanumeric
                       non-empty-string-alphanumeric)))

(s/def :common/email-address
  (s/with-gen #(and (string? %) (re-matches #".+@.+\..+" %))
    (fn [] email-generator)))
